module.exports = __webpack_public_path__ + "static/media/998149.7ee33458.jpg";